'use client';

import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider as MUIThemeProvider,
} from '@mui/material/styles';
import { deepmerge } from '@mui/utils';

import type { Theme, ThemeOptions } from '@mui/material/styles';
import type { DefaultTheme } from "@mui/system";
import type { FC, PropsWithChildren } from 'react';

interface ThemeMergerProps extends PropsWithChildren {
  palette?: ThemeOptions['palette'];
  typography?: ThemeOptions['typography'];
  spacing?: ThemeOptions['spacing'];
  zIndex?: ThemeOptions['zIndex'];
  direction?: ThemeOptions['direction'];
  shape?: ThemeOptions['shape'];
  shadows?: ThemeOptions['shadows'];
  transitions?: ThemeOptions['transitions'];
  breakpoints?: ThemeOptions['breakpoints'];
  components?: ThemeOptions['components'];
  responsiveFontSizes?: boolean;
  theme?: ThemeOptions;
  callbackFn?: (theme: Theme) => Theme;
}

// eslint-disable-next-line max-statements
export const ThemeMerger: FC<ThemeMergerProps> = ({
  children,
  theme = {},
  callbackFn,
  ...props
}) => {
  const options: ThemeOptions = { ...theme, ...props };

  return (
    <MUIThemeProvider
      theme={(defaultTheme) => {
        let newTheme = createTheme( deepmerge( defaultTheme, options ) );

        if ('responsiveFontSizes' in props) {
          newTheme = responsiveFontSizes( newTheme );
        }

        if (callbackFn) newTheme = callbackFn( newTheme );

        return newTheme as DefaultTheme;
      }}
    >
      {children}
    </MUIThemeProvider>
  );
};

// export const ThemeMerger: FC<ThemeMergerProps> = ({
//   children,
//   theme = {},
//   callbackFn,
//   ...props
// }) => (
//   <>
//     {children}
//   </>
// );
